import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import Sprite from '../Sprite';
import GameObject from '../../GameObject/GameObject';
import Point from '../../Utility/Point';
import AnimationComponent from '../../Component/Animation';
import CropComponent from '../../Component/Map/Crop';
import { Random } from '../../Utility/Random';
import { SectorLockData } from './Field';
import { StartAnimation } from '../../System/Animation/AnimationHelper';
import { GrowthStage, tCropTextureMap } from '../../State/World/IFieldData';
import SpriteComponent from '../../Component/Render/Sprite';
import { Logger, LogOrigin, LogStyles } from '../../Utility/Logger/LoggerSuite';

export default class Crop extends GameObject {
    public cropSprite: GameObject;

    public onCreate(params: {
        cropSprite: Sprite;
        textures: tCropTextureMap;
        textureOverrides?: tCropTextureMap;
        currentStage: GrowthStage;
        base: string;
        lockData: SectorLockData;
        sector: number;
    }): void {
        this.cropSprite = params.cropSprite;
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<CropComponent>(CropComponent, params);
        this.addComponent<Renderable>(Renderable);
        this.addComponent(AnimationComponent);

        const cropSpriteTransform = params.cropSprite.getComponent(TransformComponent);
        this.getComponent(TransformComponent).position.copy(cropSpriteTransform.position);

        const baseSprite = GameObject.Instantiate(Sprite, {
            name: 'base',
            texture: params.base,
            anchor: new Point(0.5, 0.5),
            scale: cropSpriteTransform.scale.clone(),
        });
        this.addChild(baseSprite);

        params.currentStage = params.lockData.newUnlock
            ? GrowthStage.LOCKED
            : params.currentStage;

        params.cropSprite.addComponent(SpriteComponent);

        const textures = (params.textureOverrides && params.textureOverrides[params.currentStage]) ?
            params.textureOverrides[params.currentStage]
            :
            params.textures[params.currentStage];

        if(!textures) {
            Logger.log(
                `No crop textures provided for ${params.currentStage}`,
                LogOrigin.CROP_GAME_OBJECT,
                LogStyles.WARNING
            );
        }

        params.cropSprite.getComponent(SpriteComponent).texture =
            params.lockData.locked && params.currentStage !== GrowthStage.LOCKED ?
                'blank'
                :
                Random.getRandomWeighted(textures);

        baseSprite.addChild(params.cropSprite);
        cropSpriteTransform.position.set(0);
        cropSpriteTransform.scale.set(1);
    }

    public init() {
        const baseSprite: GameObject = this.findChildByName('base');
        StartAnimation(baseSprite, 'Alpha', {
            startAlpha: 0,
            endAlpha: 1,
            duration: 250,
        });
    }
}
